var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { State, Action, Selector } from '@ngxs/store';
import { GalleryStateModel } from './gallery.state.model';
import { GallerySearchMode } from '../models/gallery-search-mode.enum';
import { GalleryViewMode } from '../models/gallery-view-mode.enum';
import { GalleryActions } from './gallery.actions';
import { exploreMenu } from 'src/app/explore/data/explore-menu';
import { OrganizationsService } from 'src/app/organizations/organizations.service';
import { of, forkJoin, Observable } from 'rxjs';
import { StudioOptionsModel } from '../models/studio-options.model';
import { ModulesService } from 'src/app/modules/modules.service';
import { finalize, map } from 'rxjs/operators';
import { ExploreService } from 'src/app/explore/explore.service';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';
import { BookmarksService } from 'src/app/bookmarks/bookmarks.service';
import { StoryType } from 'src/app/story/models/story-type.enum';
import * as _ from 'lodash';
var sortRecent = {
    label: 'Most Recent',
    field: ['update_date_time', 'create_date_time'],
    ascending: false
};
var sortTitleAsc = {
    label: 'Title (A-Z)',
    field: 'title',
    ascending: true
};
var sortTitleDesc = {
    label: 'Title (Z-A)',
    field: 'title',
    ascending: false
};
var sortAuthorAsc = {
    label: 'Author (A-Z)',
    field: 'author',
    ascending: true
};
var sortAuthorDesc = {
    label: 'Author (Z-A)',
    field: 'author',
    ascending: false
};
var sortOptions = [sortRecent, sortTitleAsc, sortTitleDesc, sortAuthorAsc, sortAuthorDesc];
var GalleryState = /** @class */ (function () {
    function GalleryState(organizationsService, modulesService, exploreService, bookmarksService) {
        this.organizationsService = organizationsService;
        this.modulesService = modulesService;
        this.exploreService = exploreService;
        this.bookmarksService = bookmarksService;
    }
    /**
     * Selectors
     */
    GalleryState.getLoading = function (state) {
        return state.loading;
    };
    GalleryState.getSearchMode = function (state) {
        return state.searchMode;
    };
    GalleryState.getViewMode = function (state) {
        return state.viewMode;
    };
    GalleryState.getSort = function (state) {
        return state.sort;
    };
    GalleryState.getSortOptions = function (state) {
        return state.sortOptions;
    };
    GalleryState.getStudioOptions = function (state) {
        return state.studioOptions;
    };
    GalleryState.getSearchResults = function (state) {
        if (!state.searchResults.length) {
            return [];
        }
        var collator = new Intl.Collator('en-US', { sensitivity: 'base' });
        var fields = (typeof state.sort.field === 'string') ? [state.sort.field] : state.sort.field;
        var searchResults = state.searchResults.sort(function (a, b) {
            var aValue, bValue;
            fields.forEach(function (field) {
                aValue = (aValue == null) ? _.get(a, field) : aValue;
                bValue = (bValue == null) ? _.get(b, field) : bValue;
            });
            return ((state.sort.ascending) ? 1 : -1) * collator.compare(aValue, bValue);
        });
        return searchResults;
    };
    GalleryState.getStudioCategoryId = function (state) {
        return state.studioCategoryId;
    };
    GalleryState.getStudioQuery = function (state) {
        return state.studioQuery;
    };
    /**
     * Actions
     */
    GalleryState.prototype.setSearchMode = function (context, action) {
        context.patchState({
            searchMode: action.searchMode
        });
    };
    GalleryState.prototype.setViewMode = function (context, action) {
        context.patchState({
            viewMode: action.viewMode
        });
    };
    GalleryState.prototype.setSort = function (context, action) {
        var searchResults = context.getState().searchResults;
        context.patchState({
            sort: action.sort,
            searchResults: __spread(searchResults)
        });
    };
    GalleryState.prototype.getStudioCategories = function (context, action) {
        var actions = [];
        // Get biodigital categories
        actions.push(of(exploreMenu.categories)); // title, tag
        // Get collections
        if (action.organizationId) {
            actions.push(this.organizationsService.getCollections(action.organizationId));
        }
        // Retrieve and combine various options
        forkJoin(actions)
            .subscribe(function (_a) {
            var _b = __read(_a, 2), categories = _b[0], collections = _b[1];
            var options = [];
            // Assemble various options
            options = __spread([
                new StudioOptionsModel('My Models', '', 'user'),
                new StudioOptionsModel('Biodigital Models', '', 'category')
            ], exploreMenu.categories.map(function (category) {
                return new StudioOptionsModel(category.title, category.tag, 'category');
            }));
            if (collections && collections.length) {
                options = __spread(options, [
                    new StudioOptionsModel('Team Models', '', 'collection', action.organizationId)
                ], collections.map(function (collection) {
                    return new StudioOptionsModel(collection.collection_name, collection.collection_id.toString(), 'collection', action.organizationId);
                }));
            }
            context.dispatch(new GalleryActions.GetStudioOptionsSuccess(options));
        });
    };
    GalleryState.prototype.getStudioOptionsSuccess = function (context, action) {
        context.patchState({
            studioOptions: __spread(action.options)
        });
    };
    GalleryState.prototype.searchStudio = function (context, action) {
        context.patchState({
            loading: true,
            studioQuery: action.query,
            studioCategoryId: action.category.id
        });
        var search$ = new Observable();
        // Search module services
        switch (action.category.type) {
            case 'category':
                search$ = (action.category.value === 'public') ?
                    this.bookmarksService.getPublicBookmarks(action.query) :
                    this.exploreService.getAnatomyCategory(action.query, action.category.value.toString());
                break;
            case 'collection':
                search$ = this.organizationsService.getCollectionContent(action.category.organizationId, action.category.value, action.query);
                break;
            case 'user':
                search$ = this.bookmarksService.getPrivateBookmarks(action.query);
                break;
        }
        search$
            .pipe(finalize(function () { return context.patchState({ loading: false }); }))
            .subscribe(function (results) {
            context.dispatch(new GalleryActions.SearchStudioSuccess(results));
        });
    };
    GalleryState.prototype.searchStudioSuccess = function (context, action) {
        context.dispatch(new GalleryActions.SearchSuccess(action.bookmarks));
    };
    GalleryState.prototype.searchLoft = function (context, action) {
        context.patchState({ loading: true });
        var isExplicit = action.name.indexOf('.json') > 0;
        // Search module services
        this.modulesService.listContents(action.primaryCategory, action.secondaryCategory, (isExplicit) ? action.name : '')
            .pipe(map(function (results) {
            if (!isExplicit) {
                return results.filter(function (result) { return result.name.indexOf(action.name) >= 0; });
            }
            else {
                return results;
            }
        }), finalize(function () { return context.patchState({ loading: false }); }))
            .subscribe(function (results) {
            context.dispatch(new GalleryActions.SearchLoftSuccess(results));
        }, function (err) {
            context.dispatch(new GalleryActions.SearchLoftSuccess([]));
        });
    };
    GalleryState.prototype.searchLoftSuccess = function (context, action) {
        var results = action.bookmarks.map(function (value) {
            // For loft content, ID and Label both just use filename.
            // For label, strip off the leading directories for easier parsing. 
            var id = value.name
                .replace('/content/modules/', '')
                .replace('.json', '');
            var title = value.name
                .split('/')
                .pop()
                .replace('/content/modules', '')
                .replace('.json', '');
            var bookmark = new BookmarkModel();
            bookmark.id = id;
            bookmark.title = title;
            bookmark.type = StoryType.Module;
            return bookmark;
        });
        context.dispatch(new GalleryActions.SearchSuccess(results));
    };
    GalleryState.prototype.searchSuccess = function (context, action) {
        context.patchState({
            searchResults: action.bookmarks
        });
    };
    GalleryState.prototype.clearResults = function (context, action) {
        context.patchState({
            searchResults: []
        });
    };
    __decorate([
        Action(GalleryActions.SetSearchMode),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GalleryActions.SetSearchMode]),
        __metadata("design:returntype", void 0)
    ], GalleryState.prototype, "setSearchMode", null);
    __decorate([
        Action(GalleryActions.SetViewMode),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GalleryActions.SetViewMode]),
        __metadata("design:returntype", void 0)
    ], GalleryState.prototype, "setViewMode", null);
    __decorate([
        Action(GalleryActions.SetSort),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GalleryActions.SetSort]),
        __metadata("design:returntype", void 0)
    ], GalleryState.prototype, "setSort", null);
    __decorate([
        Action(GalleryActions.GetStudioOptions),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GalleryActions.GetStudioOptions]),
        __metadata("design:returntype", void 0)
    ], GalleryState.prototype, "getStudioCategories", null);
    __decorate([
        Action(GalleryActions.GetStudioOptionsSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GalleryActions.GetStudioOptionsSuccess]),
        __metadata("design:returntype", void 0)
    ], GalleryState.prototype, "getStudioOptionsSuccess", null);
    __decorate([
        Action(GalleryActions.SearchStudio),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GalleryActions.SearchStudio]),
        __metadata("design:returntype", void 0)
    ], GalleryState.prototype, "searchStudio", null);
    __decorate([
        Action(GalleryActions.SearchStudioSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GalleryActions.SearchStudioSuccess]),
        __metadata("design:returntype", void 0)
    ], GalleryState.prototype, "searchStudioSuccess", null);
    __decorate([
        Action(GalleryActions.SearchLoft),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GalleryActions.SearchLoft]),
        __metadata("design:returntype", void 0)
    ], GalleryState.prototype, "searchLoft", null);
    __decorate([
        Action(GalleryActions.SearchLoftSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GalleryActions.SearchLoftSuccess]),
        __metadata("design:returntype", void 0)
    ], GalleryState.prototype, "searchLoftSuccess", null);
    __decorate([
        Action(GalleryActions.SearchSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GalleryActions.SearchSuccess]),
        __metadata("design:returntype", void 0)
    ], GalleryState.prototype, "searchSuccess", null);
    __decorate([
        Action(GalleryActions.ClearResults),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GalleryActions.ClearResults]),
        __metadata("design:returntype", void 0)
    ], GalleryState.prototype, "clearResults", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [GalleryStateModel]),
        __metadata("design:returntype", void 0)
    ], GalleryState, "getLoading", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [GalleryStateModel]),
        __metadata("design:returntype", void 0)
    ], GalleryState, "getSearchMode", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [GalleryStateModel]),
        __metadata("design:returntype", void 0)
    ], GalleryState, "getViewMode", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [GalleryStateModel]),
        __metadata("design:returntype", void 0)
    ], GalleryState, "getSort", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [GalleryStateModel]),
        __metadata("design:returntype", void 0)
    ], GalleryState, "getSortOptions", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [GalleryStateModel]),
        __metadata("design:returntype", void 0)
    ], GalleryState, "getStudioOptions", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [GalleryStateModel]),
        __metadata("design:returntype", void 0)
    ], GalleryState, "getSearchResults", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [GalleryStateModel]),
        __metadata("design:returntype", void 0)
    ], GalleryState, "getStudioCategoryId", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [GalleryStateModel]),
        __metadata("design:returntype", void 0)
    ], GalleryState, "getStudioQuery", null);
    GalleryState = __decorate([
        State({
            name: 'gallery',
            defaults: {
                loading: true,
                searchMode: GallerySearchMode.Query,
                viewMode: GalleryViewMode.Cards,
                sort: sortTitleAsc,
                sortOptions: sortOptions,
                studioOptions: [],
                studioQuery: '',
                studioCategoryId: 'category||',
                searchResults: [],
                checkedResults: []
            }
        }),
        __metadata("design:paramtypes", [OrganizationsService,
            ModulesService,
            ExploreService,
            BookmarksService])
    ], GalleryState);
    return GalleryState;
}());
export { GalleryState };
